import { Injectable } from '@angular/core';
import {
  catchError,
  first,
  take,
  takeUntil,
  withLatestFrom,
} from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { SubscriptionDisposerComponent } from 'src/app/shared/disposer/subscription-disposer.component';
import { CommonApiService } from 'src/app/shared/common-api.service';
import { environment } from 'src/environments/environment';
import { LogModel } from 'src/app/player/models/log';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { LogTypes } from './state/logs.actions';
import { PlayerFacade } from 'src/app/player/player.facade';
import { LocationModel } from 'src/app/player/models/location';
import { Device, DeviceInfo } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class LogService extends SubscriptionDisposerComponent {
  private baseUrl: string;
  private location: LocationModel;
  private errorEmitted: boolean;
  private intialInterval: NodeJS.Timeout;

  constructor(
    private commonApiService: CommonApiService,
    private store: Store<AppState>,
    private playerFacade: PlayerFacade
  ) {
    super();
    this.baseUrl = environment.apiEndpoint;
  }

  send(logs: LogModel[]) {
    const payload = {
      payload: logs,
    };
    this.commonApiService
      .postRequest('logs', payload)
      .pipe(first())
      .subscribe(
        () => {},
        () => {}
      );
  }

  sendMessage(message: string, type: LogTypes) {
    this.deviceInfo().then((value: DeviceInfo) => {
      if (message.includes('Error trying to play')) {
        clearTimeout(this.intialInterval);
        // emit error for 10minutes
        this.errorEmitted = true;
        this.intialInterval = setTimeout(() => {
          this.errorEmitted = false;
        }, 300000);
      }
      message = this.errorEmitted ? '[Error emitted] ' + message : message;

      of([])
        .pipe(withLatestFrom(this.playerFacade.location$), take(1))
        .subscribe(([arr, location]) => {
          // eslint-disable-next-line max-len
          const logValue: LogModel[] = [
            {
              type: type ? type : LogTypes.info,
              message: `${message}`,
              timestamp: '',
              locationGuid: `${location?.guid}`,
              locationName: `${location?.name}`,
              version: '',
              compilation: '',
              longitude: location?.longitude,
              latitude: location?.latitude,
              os: value.operatingSystem,
              osVersion: value.osVersion,
              platform: value.platform,
              diskFree: value.realDiskFree,
              deviceManufacturer: value.manufacturer,
            },
          ];
          this.send(logValue);
        });
    });
  }

  async deviceInfo() {
    // eslint-disable-next-line arrow-body-style
    const deviceOperatingSystem = await Device.getInfo().then(
      async (value: DeviceInfo) => await value
    );
    return deviceOperatingSystem;
  }
}
